import localFont from 'next/font/local';
import { Noto_Sans } from 'lib/fonts/local-font-references';

const poppins = localFont({
  src: [
    { path: '../../../public/fonts/poppins-400.woff2', weight: '400' },
    { path: '../../../public/fonts/poppins-700.woff2', weight: '700' },
    { path: '../../../public/fonts/poppins-900.woff2', weight: '900' },
  ],
  display: 'swap',
  variable: '--font-poppins',
  declarations: [{ prop: 'font-family', value: 'Poppins' }],
});

const notoSans = Noto_Sans({
  subsets: ['latin'],
  display: 'swap',
  variable: '--font-noto-sans',
  weight: ['400', '700'],
});

export const supportedFonts = [poppins, notoSans];
